import {
  FeatureName,
  useIsFeatureEnabled,
} from '@gripp/shared-logic';
import { SlideLayout } from '@gripp/shared-ui';
import { StyleSheet } from 'react-native';
import { Accounts as AccountsOld } from './accounts-old';
import { AccountsComponent } from './accountsComponent';
import { AccountsFilters } from './accountsFilters';

export const Accounts = () => {
  const isCropCircleEnabled = useIsFeatureEnabled(FeatureName.CropCircleRedesign);

  if (isCropCircleEnabled) {
    return <AccountsBase />;
  }

  return <AccountsOld />;
};

const AccountsBase = () => {
  const leftColumn = {
    title: 'people.menu.people',
    mainComponent: <AccountsComponent />,
    headerComponent: <AccountsFilters />,
    disableScroll: true
  };

  return (
    <SlideLayout 
      leftColumn={leftColumn}
    />
  )
};

const styles = StyleSheet.create({
  exportContainer: {
    marginLeft: 'auto',
  },
});
